module.exports = __webpack_public_path__ + "f02d333dcf3a9396ce79b4f31230c7fa.png";